import React from 'react';

import { TextButton } from '@components/Button/variants';
import { useEventTracking } from '@hooks';
import { ClickTarget, click } from '@tracking';

import { EVENTS_EMAIL_ADDRESS, SPONSORSHIPS_EMAIL_ADDRESS } from './constant';

const GetInTouch = () => {
  const { trackEvent } = useEventTracking();
  return (
    <article className="mx-auto max-w-[1728px]">
      <div className="mt-112 bg-grayscale-beige px-16 py-72 sm:px-28">
        <div className="mx-auto flex max-w-container-lg justify-center">
          <div className="flex w-full flex-col items-start justify-around sm:w-[90%]">
            <h2 className="mt-0 font-suisse-intl-mono text-headline-lg text-black">Get in touch</h2>
            <div className="flex flex-wrap gap-48 sm:gap-64">
              <p className="m-0 max-w-full sm:max-w-[360px]">
                Contact our events team directly if you have any additional questions,{' '}
                <TextButton
                  as="link"
                  className="!inline underline hover:text-primary-magenta"
                  href="mailto:events@theinformation.com"
                  onClickCapture={() =>
                    trackEvent(
                      click({
                        clickTarget: ClickTarget.AnchorLink,
                        clickText: EVENTS_EMAIL_ADDRESS,
                      })
                    )
                  }
                >
                  {EVENTS_EMAIL_ADDRESS}
                </TextButton>
                .
              </p>
              <p className="m-0 max-w-full sm:max-w-[300px]">
                For sponsorship opportunities, email{' '}
                <TextButton
                  as="link"
                  href="mailto:sponsorships@theinformation.com"
                  className="!inline underline hover:text-primary-magenta"
                  onClickCapture={() =>
                    trackEvent(
                      click({
                        clickTarget: ClickTarget.AnchorLink,
                        clickText: SPONSORSHIPS_EMAIL_ADDRESS,
                      })
                    )
                  }
                >
                  {SPONSORSHIPS_EMAIL_ADDRESS}
                </TextButton>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default GetInTouch;
